const getDate = (date: string = '', format: '' | 'dd/mm/yyyy' | 'object' = '') => {
  let lDate: any

  if(date === '') {
    lDate = new Date()
  } else {
    lDate = new Date(date)
  }

  const year: string = String(lDate.getFullYear())
  const month: string = String(lDate.getMonth() + 1).padStart(2, '0')
  const day: string = String(lDate.getDate()).padStart(2, '0')

  if(format === '') {
    return `${year}-${month}-${day}`

  } else if(format === 'dd/mm/yyyy') {
    return `${day}/${month}/${year}`

  } else if(format === 'object') {
    return {
      year,
      month,
      day
    }
  }
}

const getDateDbObject = (date: string) => {
  if(!date) return ''

  const aDate = date.split('-')

  return {
    year: aDate[0],
    month: aDate[1],
    day: (aDate[2].length > 2 ? aDate[2].substring(0, 2) : aDate[2])
  }
}

const isObjectEmpty = (obj: any) => JSON.stringify(obj) === '{}'

const getRutFormat = (rut: string, option: 'COMPLETE' | '' = '') => {
  if(!rut) return ''

  let fRut = rut.substring(0, rut.length - 1)
  const fRutCode = rut.substring(rut.length - 1, rut.length)

  if(option === 'COMPLETE') {
    fRut = fRut.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }

  return `${fRut}-${fRutCode}`
}

const getImagenBase64 = (base64: string): string => {
  return `data:image/jpeg;base64,${base64}`
}

const getDateViewFormat = (date: string) => {
  if(!date) return ''

  const aDate = date.split('-')

  return `${aDate[2]} / ${aDate[1]} / ${aDate[0]}`
}

const getDateFormat = (date: string | Date, format: 'YYYY/MM/DD' | 'DD/MM/YYYY' | 'DATE' | 'OBJECT' | 'YYYY-MM-DD' = 'DATE') => {
  if(!date) return ''

  let year: string
  let month: string
  let day: string

  if(typeof date === 'string') {
    const aDate: any = getDateDbObject(String(date))

    year = aDate.year
    month = aDate.month
    day = aDate.day

  } else {
    year = String(date.getFullYear())
    month  = String(date.getMonth() + 1).padStart(2, '0')
    day = String(date.getDate()).padStart(2, '0')
  }

  if(format === 'YYYY/MM/DD') return `${year}/${month}/${day}`
  else if(format === 'DD/MM/YYYY') return `${day}/${month}/${year}`
  else if(format === 'YYYY-MM-DD') return `${year}-${month}-${day}`
  else if(format === 'OBJECT') return { year, month, day }
  return new Date(`${year}/${month}/${day}`)
}

const getArrayBooleanDefault = (quantity: number) => {
  return new Array(quantity).fill(false)
}

const isBrowserByName = (browserName: 'CHROME' | 'FIREFOX') => {
  const navAgent = (agentName: string) => navigator.userAgent.indexOf(agentName)

  if(!!navigator.userAgent) {
    if(browserName === 'CHROME') {
      return ((navAgent('Chrome') > -1 || navAgent('CriOS') > -1) && navAgent('Edg') === -1 && navAgent('OPR') === -1)

    } else if(browserName === 'FIREFOX') {
      return (navAgent('Mozilla') > -1 && navAgent('Firefox') > -1)
    }
  }
  return false
}

export {
  getDate,
  getDateDbObject,
  getDateFormat,
  isObjectEmpty,
  getRutFormat,
  getImagenBase64,
  getDateViewFormat,
  getArrayBooleanDefault,
  isBrowserByName
}